<template>
  <div class="repairDetail">
    <div class="card basic">
      <div class="title">基本信息</div>
<!--      <div class="cell">-->
<!--        <div class="li">订单编号</div>-->
<!--        <div class="licontent">{{details.OrderCode}}</div>-->
<!--      </div>-->
      <div class="cell">
        <div class="li">校区</div>
        <div class="licontent">{{details.BizRegionInfo.FullName}}</div>
      </div>
      <div class="cell">
        <div class="li">寝室</div>
        <div class="licontent">{{details.FullAddress}}</div>
      </div>
    </div>
    <div class="card">
      <div class="title">报修信息</div>
      <div class="cell">
        <div class="li">报修时间</div>
        <div class="licontent">{{details.CreateTimeStr}}</div>
      </div>
      <div class="cell">
        <div class="li">报修来源</div>
        <div class="licontent">{{details.Source}}</div>
      </div>
      <div class="cell">
        <div class="li">报修状态</div>
        <div class="licontent">{{details.State}}</div>
      </div>
      <div class="textarea">
        <div class="li">报修内容</div>
        <div class="licontent">{{details.Text || '暂无'}}</div>
      </div>
<!--      <div class="textarea">-->
<!--        <div class="li">维修备注</div>-->
<!--        <div class="licontent">{{details.FormMessage || '暂无'}}</div>-->
<!--      </div>-->
    </div>
    <div class="card" v-if="details.BizDormitoryInfo.BizEquipmentListInfos.length">
      <div class="title">报修设备信息</div>
      <div class="cell">
        <div class="li">设备编号</div>
        <div class="licontent">{{details.BizDormitoryInfo.BizEquipmentListInfos[0].Code}}</div>
      </div>
      <div class="cell">
        <div class="li">设备二维码</div>
        <div class="licontent">{{details.BizDormitoryInfo.BizEquipmentListInfos[0].QRCode}}</div>
      </div>
      <div class="textarea">
        <div class="li">设备型号</div>
        <div class="licontent">{{details.BizDormitoryInfo.BizEquipmentListInfos[0].VersionFullName}}</div>
      </div>
      <div class="cell">
        <div class="li">设备状态</div>
        <div class="licontent" :style="{color: details.BizDormitoryInfo.BizEquipmentListInfos[0].State === '已安装' ? '#19C82A' : '#FFC107'}">{{details.BizDormitoryInfo.BizEquipmentListInfos[0].State}}</div>
      </div>
    </div>
    <div class="card">
      <div class="title">操作流程</div>
      <van-steps direction="vertical" :active="0">
        <van-step v-for="item in orderFlow" :key="item.Id" class="step-group-item">
          <div class="time">
            {{ item.CreateTimeStr }}
          </div>
          <div class="title">{{ item.Type }}</div>
          <div class="text">
            {{ item.Text }}
          </div>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import trSteps from '@/components/trSteps'
  export default {
  name: 'repairDetail',
  data() {
    return {
      detailsOrder: {},
      orderFlow: [],
      BizOrderPackageInfo: {
        Price: 0,
        CreateTimeStr: '0000-00-00',
        Deposit: 0,
        Code: 0
      },
      Id: '',
      details: {
        BizRegionInfo: {},
        BizDormitoryInfo: {
          BizEquipmentListInfos: []
        }
      }
    }
  },
    components: {
      trSteps
    },
  methods: {
    getOrderFlow() {
      let url = ''
      let params = {}
      if(this.$route.query.type === '报修') {
        url = '/BizMemberServiceFlow/AllList'
        params.ServiceId = this.$route.query.Id
      } else {
        url = '/BizMemberReturnFlow/AllList'
        params.ReturnId = this.$route.query.Id
      }
      this.$post(url, params).then(res => {
        if(res) {
          this.orderFlow = res.Data
        }
      })
    },
    getDetail() {
      let url;
      if(this.$route.query.type === '退租') {
        url = '/BizMemberReturn/Details'
      } else {
        url = '/BizMemberService/Details'
      }
      this.$post(url, {Id: this.$route.query.Id}).then(res => {
        if(res) {
          this.details = res.Data
          if (this.$route.query.type === '退租') this.getOrderDetails(res.Data.OrderId)
        }
      })
    },
    getOrderDetails(id) {
      this.$post('/BizMemberOrder/Details', {Id: id}).then(res => {
        if(res) {
          this.detailsOrder = res.Data
          this.BizOrderPackageInfo = res.Data.BizOrderPackageInfo
          this.BizOrderPackageInfo.ValidityEndTimeStr = res.Data.EndTimeStr
        }
      })
    }
  },
  mounted() {
    this.getDetail()
    this.getOrderFlow()
  }
}
</script>

<style scoped lang="less">
.repairDetail{
  .card{
    margin: 0.2rem;
    background-color: #fff;
    border-radius: 8px;
    padding: 15px;
    color: #3D3D3D;
    .title{
      color: #333333;
      display: flex;
      font-size: 18px;
      font-weight: bold;
      align-items: center;
    }

    .cell {
      display: flex;
      margin-top: 10px;
      width: 100%;

      >div{
        width: 100%;

        &.li{
          width: 100px;
          flex-shrink: 0;
        }
        &.licontent{
          text-align: right;
        }
      }
    }

    .textarea{
      margin-top: 10px;
      .licontent{
        margin: 5px 0;
        background-color: #FAFAFA;
        padding: 10px;
        border-radius: 8px;
      }
    }
  }

  .step-group-item{
    .time{
      font-size: 12px;
      background-color: rgba(246, 246, 246);
      color: rgba(174, 174, 174);
      border-radius: 10px;
      padding: 2px 15px;
    }
    .title{
      font-size: 14px!important;
      margin: 15px 0 10px 0;
      color: #333333;
    }
    .text{
      font-size: 14px;
      word-break: break-all;
      color: rgba(174, 174, 174);
      line-height: 20px;
    }
  }

}
</style>
